import component from './CopyToClipboard'

export default component
